import React, { useEffect, useRef, useState } from "react";
import { debounce } from "../../helpers";

interface image {
  cropKey: string;
  imageUrl: string | null;
}

interface widgetInterface {
  children: JSX.Element;
  infoText?: JSX.Element;
  backgroundImage?: image[];
  showWtnWidget?: boolean;
  logoWatermark?: boolean;
  widgetHyperlink?: string;
}

const widgetWrapper = (props: widgetInterface) => {
  const [Component, setChildren]: any = useState({
    children: <></>,
    active: false
  });
  let wrapper: any = useRef({ current: <div /> });
  const [infoDisplay, updateInfoDisplay] = useState(false);
  const [displayWidget, updateDisplay] = useState(false);

  const func = () => {
    const inView =
      window.innerHeight + window.pageYOffset >
      (wrapper.current ? wrapper.current.offsetTop : 1);

    if (props.showWtnWidget && inView) {
      setChildren({ children: props.children, active: true });
      updateDisplay(true);
    }
  };

  useEffect(() => {
    if (wrapper.current) {
      debounce({ event: "scroll", func });

      if (!Component.children.active) {
        // only triggers if widget isn't mounted
        func();
      }
    }
  }, []);

  return (
    <div
      ref={wrapper}
      className={`pprofile-overview__ranking-section pprofile-overview__ranking-section--wtn${
        displayWidget ? " inView" : ""
        }`}
      style={{ maxHeight: `${displayWidget ? "900px" : "0"}` }}
    >
      <h3>
        <a
          href={
            props.widgetHyperlink
              ? props.widgetHyperlink
              : "https://www.worldtennisnumber.com/"
          }
          target="_blank"
        >
          ITF World Tennis Number
        </a>
      </h3>
      <div
        className="widget-wrapper-bg"
        style={{
          display: Component.active ? "flex" : "none",
          backgroundImage: `${
            !!props.backgroundImage && props.backgroundImage.length
              ? "url(" +
              process.env.HOST +
              props.backgroundImage.filter(
                (img: image) => img.cropKey === "Large"
              )[0].imageUrl +
              ")"
              : ""
            }`
        }}
      >
        <div
          className={`widget-wrapper${props.logoWatermark ? " watermark" : ""}`}
        >
          <div className="widget-player-info">
            <div className="widget-player-details">
              <span>{props.infoText}</span>
            </div>
          </div>
          <div className="widget">
            {React.cloneElement(Component.children)}
            <a
              href={
                props.widgetHyperlink
                  ? props.widgetHyperlink
                  : "https://www.worldtennisnumber.com/"
              }
              className="WTN-overlay-cta"
              target="_blank"
            ></a>
          </div>
          <span className={`info-text-mobile${infoDisplay ? " show" : ""}`}>
            {props.infoText}
          </span>
          <div
            onClick={() => updateInfoDisplay(!infoDisplay)}
            className="info-icon"
          >
            i
          </div>
        </div>
      </div>
    </div>
  );
};

export default widgetWrapper;
